var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './CaenCodeSection.scss';
import CaenCodeCard from '../CaenCodeCard/CaenCodeCard';
var CaenCodeSection = function (props) {
    var caenCodes = props.caenCodes;
    var primaryCaenCode = caenCodes.find(function (cc) { return cc.IsPrimary == true; });
    var secondaryCaenCodes = caenCodes.filter(function (cc) { return cc.IsPrimary == false; });
    var standardTaxationCode = caenCodes.find(function (cc) { return cc.HasStandardTaxation == true; });
    return (_jsxs("div", __assign({ className: "caen-code-section" }, { children: [_jsx("h2", __assign({ className: "caen-code-section__heading" }, { children: "Coduri CAEN" })), _jsxs("div", __assign({ className: "caen-code-section__container--grid" }, { children: [_jsx(CaenCodeCard, { hasStandardTaxation: false, primaryCaenCode: primaryCaenCode, secondaryCaenCodes: secondaryCaenCodes }), _jsx(CaenCodeCard, { hasStandardTaxation: true, primaryCaenCode: standardTaxationCode })] }))] })));
};
export default CaenCodeSection;
